function advance(i,skipped){
  if(skipped)answers[i]=[];
  if(i<QUESTIONS.length-1)showQuestion(i+1);
  else showPause();
}

function showPause(){
  transition(()=>{
    stage.innerHTML=`
    <div class="room"><div class="plate">${corners}<div class="pause">
      ${crestTag}
      <h2 class="pause-title">Composing your ritual</h2>
      <p>Every answer has led us here.</p>
      <p>We’re thoughtfully selecting the formulas that belong together for your skin.</p>
      <p class="pause-wait">Just a moment.</p>
    </div></div></div>`;
    announcer.textContent="Composing your ritual.";
    setTimeout(showResult, reduced?0:2600);
  });
}

/* Rendering only. Every result below comes from composeRitual(answers) in
   the-consultation-engine.js: the same function the routing grid calls. */
function showResult(){
  const res=composeRitual(answers);
  transition(()=>{
    const card=it=>`
        <div class="step${it.opt?' optstep':''}">
          ${prodTile(P[it.k],'')}
          <div>
            <h3 class="role">${it.role}${it.opt?'<span class="optchip">Optional</span>':''}</h3>
            <p class="pname"><a href="${P[it.k].u}" target="_blank" rel="noopener">${P[it.k].n}</a></p>
            <p class="why">${it.why}</p>
            <button class="add-ritual" onclick="addRitual(this,'${it.k}')">Add to Ritual</button>
          </div>
        </div>`;
    const secs=res.chapters.map(s=>{
      const hero=s.items.find(it=>it.slot==='seal-hero')||null;
      const treats=(hero||s.head==='Evening')?s.items.filter(it=>it.slot==='treat'):[];
      let body;
      if(hero){
        const ordinarySeal=s.items.find(it=>it.slot==='seal')||null;
        const shared=s.items.filter(it=>it!==hero&&it!==ordinarySeal&&it.slot!=='treat'&&it.slot!=='eye');
        const eyes=s.items.filter(it=>it.slot==='eye');
        body=`
        ${shared.length?`<div class="ritual">${shared.map(card).join('')}</div>`:''}
        <div class="tracks">
          <p class="tracks-note">The evening ends one of two ways · one seal per night, never both</p>
          <div class="tracks-grid">
            <div class="track">
              <h3 class="track-head">Ordinary Nights</h3>
              <p class="track-sub">Most evenings of the week</p>
              ${ordinarySeal?card(ordinarySeal):''}
              <p class="track-final">The final moisturizer on these nights</p>
            </div>
            <div class="track hero">
              <h3 class="track-head">Resilience Nights</h3>
              <p class="track-sub">Two or three nights a week</p>
              ${card(hero)}
              <p class="track-final">The final overnight seal · nothing goes over it</p>
            </div>
          </div>
        </div>
        ${eyes.length?`<div class="eye-ritual"><h3 class="mini-head">The eye area</h3><div class="ritual">${eyes.map(card).join('')}</div></div>`:''}`;
      }else{
        body=`<div class="ritual">${s.items.filter(it=>!treats.includes(it)).map(card).join('')}</div>`;
      }
      const special=treats.length?`
        <div class="special">
          <h3 class="special-head">Special Care · Once Weekly</h3>
          <p class="special-sub">Kept apart from the nightly ritual · reach for this one evening a week</p>
          ${treats.map(card).join('')}
        </div>`:'';
      const chap=s.head?`<div class="chap-head"><h2 class="sec-head">${s.head}</h2><p class="chap-line">${s.head==='Morning'?'The first light':'The quiet hours'}</p></div>`:'';
      return `<section class="secwrap${s.head?(' chapter '+(s.head==='Morning'?'am':'pm')):''}">${chap}
        ${body}
        ${s.spf?`<p class="spf-line">For daytime rituals, finish with your preferred SPF.</p>`:''}
        ${special}</section>`;
    }).join('');
    const benchPs=res.bench.map(id=>`<p><span class="bname">${P[id].n}</span><br>${BENCH[id]}</p>`).join('');
    const enh=res.enhance.length?`
      <div class="enh"><h3>If you would like one more thing</h3>${res.enhance.map(e=>`
      <div class="step">
        ${prodTile(P[e.k],'')}
        <div>
          <h3 class="role">${P[e.k].n}</h3>
          <p class="why">${e.text} <a class="pname" href="${P[e.k].u}" target="_blank" rel="noopener" style="font-style:italic">View at the house</a></p>
        </div>
      </div>`).join('')}</div>`:'';
    stage.innerHTML=`
    <div class="room"><div class="plate">${corners}
      <div class="reveal-head">
        ${crestTag}
        <p class="eyebrow">Your Butter &amp; Blush Ritual</p>
        <h1 class="rtitle">${res.title}</h1>
        ${res.timingLine?`<p class="twolights">${res.timingLine}</p>`:''}
        <p class="told">${res.told}</p>
      </div>
      ${secs}
      <div class="seq"><h3>The sequence</h3><p>${res.seq}</p></div>
      <div class="bench"><h3>From the formulation bench</h3>${benchPs}</div>
      ${enh}
      <div class="restart-row"><button class="btn ghost" onclick="restart()">Begin again</button></div>
      ${footTag}
    </div></div>`;
    announcer.textContent=`Your Butter and Blush Ritual: ${res.title}`;
  });
}

function restart(){answers=QUESTIONS.map(()=>[]);showThreshold();}

function initFromHash(){
  const h=location.hash; if(!h) return false;
  if(h==='#tour'){startTour(); return true;}
  let m=h.match(/^#q([1-7])$/);
  if(m){showQuestion(+m[1]-1); return true;}
  m=h.match(/^#path-([a-z]+)$/);
  if(m && CANONICAL[m[1]]){
    answers=CANONICAL[m[1]].map(x=>x.slice());
    showResult(); return true;
  }
  m=h.match(/^#a=([0-9+]*(\.[0-9+]*){6})(@(\d+))?$/);
  if(m){
    answers=m[1].split('.').map(g=>g===''?[]:g.split('+').map(Number));
    showResult();
    if(m[4])setTimeout(()=>window.scrollTo({top:+m[4]}),900);
    return true;
  }
  return false;
}
/* Review deep links: #q3 opens a question. #path-daniela loads that path's
   canonical REAL answers and routes them through composeRitual. #a=1+2.1.4.2.1.0.3
   sets any answer combination (seven groups split by dots, indices joined by +,
   empty group = skipped question) and routes it for real.
   There is no preview mechanism anywhere in this file. */
/* QA tour: cycles the key screens on a timer so they can be reviewed or
   captured without clicks. Reached only via #tour; routing untouched. */
const TOUR=[
 {name:'opening',go:()=>showThreshold()},
 {name:'question I',go:()=>showQuestion(0)},
 {name:'question II',go:()=>showQuestion(1)},
 {name:'question III',go:()=>showQuestion(2)},
 {name:'question IV',go:()=>showQuestion(3)},
 {name:'question V',go:()=>showQuestion(4)},
 {name:'question VI',go:()=>showQuestion(5)},
 {name:'question VII',go:()=>showQuestion(6)},
 {name:'result: Even-Tone Luminosity, real answers',go:()=>{answers=CANONICAL.daniela.map(x=>x.slice());showResult();},scroll:640},
 {name:'result: Overnight Resilience, real answers',go:()=>{answers=CANONICAL.mara.map(x=>x.slice());showResult();},scroll:640},
 {name:'result: Firmness & Bounce, morning, real answers',go:()=>{answers=CANONICAL.petra.map(x=>x.slice());showResult();},scroll:620},
 {name:'result: Firmness & Bounce, evening, real answers',go:()=>{answers=CANONICAL.petra.map(x=>x.slice());showResult();},scroll:2300},
 {name:'result: Balanced Clarity, real answers',go:()=>{answers=CANONICAL.bianca.map(x=>x.slice());showResult();},scroll:640},
 {name:'QA: all 19 product images',go:()=>showImageGrid(),scroll:300},
];
function showImageGrid(){
  const tiles=Object.values(P).map(p=>`<div><div class="pframe"><img src="${p.img}" alt="${p.n}"
    onerror="this.parentElement.classList.add('img-missing')">
    <div class="img-missing-note"><img src="${MONOGRAM}" alt=""><span>image unavailable</span></div></div>
    <p>${p.n}</p></div>`).join('');
  stage.innerHTML=`<div class="room"><div class="plate">${corners}${houseHead(false)}
    <h1 class="qtext" style="max-width:30ch">QA: the 19-product registry</h1>
    <p class="qhelper" id="gridcount">Counting rendered images&hellip;</p>
    <div class="qa-grid">${tiles}</div>${footTag}</div></div>`;
  const check=()=>{const im=[...document.querySelectorAll('.qa-grid .pframe > img')];
    const ok=im.filter(i=>i.complete&&i.naturalWidth>0).length;
    document.getElementById('gridcount').textContent=ok+' of '+im.length+' product images rendered';};
  setTimeout(check,1800); setTimeout(check,4500);
}
function startTour(){
  let i=0;
  const lbl=document.createElement('div');
  lbl.style.cssText='position:fixed;bottom:10px;right:12px;font-size:11px;letter-spacing:.12em;color:#A98D4B;background:rgba(242,240,232,.92);border:1px solid rgba(38,59,41,.3);padding:5px 12px;z-index:99;font-family:Georgia,serif';
  document.body.appendChild(lbl);
  const step=()=>{
    const t=TOUR[i%TOUR.length];
    document.getElementById('bb-consultation').classList.toggle('msim',!!t.mobile);
    t.go();
    lbl.textContent='QA preview '+((i%TOUR.length)+1)+' of '+TOUR.length+' · '+t.name;
    setTimeout(()=>{if(t.scroll)window.scrollTo({top:t.scroll});},1100);
    i++; setTimeout(step,7000);
  };
  step();
}

if(!initFromHash()) showThreshold();
